import { gql } from '../../generated'

export const FETCH_INTEGRATED_PHONE_CALL_GUID_BY_EXTERNAL_CALL_ID_QUERY = gql(`
query FetchIntegratedPhoneCallGuidByExternalCallId($externalCallId: String!) {
  integratedPhoneCalls(where: {externalCallId: {_eq: $externalCallId}}) {
    integratedPhoneCallGuid
  }
}
`)
